import { message as $message } from 'antd'
import { queryOperation, queryKaList } from '@/services/docking'

import { querySupplierTag, queryChannelTag } from '@/services/supplier'

const adminModel = {
    namespace: 'admin',
    state: {
        dockingList: [],
        tailCategoryList: [],
        supplierTagList: [],
        channelTagList: [],
        channelList: [],
        regionList: [],
        kaList: [],
    },
    effects: {
        *queryDockingList({ payload }, { call, put }) {
            const response = yield call(queryOperation, payload)

            if (response) {
                const { success, message, data } = response

                if (success) {
                    yield put({
                        type: 'update',
                        payload: {
                            dockingList:
                                (data &&
                                    data.map(item => {
                                        return {
                                            orgId: item.orgId,
                                            dockingName: item.fullName,
                                            dockingPeopleId: item.id,
                                            dockingPhone: item.phone,
                                            dockingQqNum: item.qqNum,
                                            dockingRemark: item.remark,
                                            dockingWeiXinNum: item.weixinNum,
                                            disabled: item.disabled,
                                        }
                                    })) ||
                                [],
                        },
                    })
                } else {
                    $message.error(message)
                }
            }
        },

        *querySupplierTagList({ payload: _ignorePayload }, { call, put }) {
            const response = yield call(querySupplierTag)

            if (response) {
                const { success, message, data } = response

                if (success) {
                    yield put({
                        type: 'update',
                        payload: {
                            supplierTagList: data || [],
                        },
                    })
                } else {
                    $message.error(message)
                }
            }
        },
        *queryChannelTagList({ payload: _ignorePayload }, { call, put }) {
            const response = yield call(queryChannelTag)

            if (response) {
                const { success, message, data } = response

                if (success) {
                    yield put({
                        type: 'update',
                        payload: {
                            channelTagList: data || [],
                        },
                    })
                } else {
                    $message.error(message)
                }
            }
        },
        *queryKaConfigList({ payload: _ignorePayload }, { call, put }) {
            const response = yield call(queryKaList)

            if (response) {
                const { success, message, data } = response
                if (success) {
                    yield put({
                        type: 'update',
                        payload: {
                            kaList: data || [],
                        },
                    })
                } else {
                    $message.error(message)
                }
            }
        },
    },
    reducers: {
        update(state, { payload }) {
            return {
                ...state,
                ...payload,
            }
        },
    },
}

export default adminModel
